export enum TradeType {
    IMPORT = 'import',
    EXPORT = 'export'
}
